import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  openErrorSnackbar(message: string, duration?: number): void {
    this.openSnackbar(message, "error", duration);
  }

  openSuccessSnackbar(message: string): void {
    this.openSnackbar(message, "success");
  }

  private openSnackbar(
    message: string,
    panelClass: string,
    duration?: number,
  ): void {
    this.snackBar.open(message, "x", {
      verticalPosition: "bottom",
      panelClass,
      duration: duration ? duration : 10000,
    });
  }
}
